var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "btn mt-4 dm-btn-padding dm-view-as-pdf",
          on: {
            click: function($event) {
              return _vm.openSignInModal()
            }
          }
        },
        [_vm._v("Download Material")]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            size: "lg",
            id: "dm-signup-modal",
            title: "Create an Account"
          }
        },
        [
          _c(
            "div",
            { staticClass: "card-body pt-3 pb-3" },
            [
              _c("SignUpForm", {
                on: {
                  showSignInModal: function($event) {
                    return _vm.openSignInModal()
                  },
                  showSignUpModal: function($event) {
                    return _vm.openSignUpModal()
                  },
                  closeAllModals: function($event) {
                    return _vm.closeAllModals()
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        { attrs: { size: "lg", id: "dm-signin-modal", title: "Log in" } },
        [
          _c(
            "div",
            { staticClass: "card-body pt-3 pb-3" },
            [
              _c("SignInForm", {
                on: {
                  showSignUpModal: function($event) {
                    return _vm.openSignUpModal()
                  },
                  closeAllModals: function($event) {
                    return _vm.closeAllModals()
                  }
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }